<div class="grid h-full grid-cols-1 xl:grid-cols-2">
  <div class="hidden flex-col items-center gap-4 bg-secondary-5 xl:flex xl:px-5 2xl:px-20">
    <img ngSrc="assets/images/activation_hero.png" class="my-auto max-w-[50%] object-contain" alt="activation-hero" height="1109" width="1128" />
  </div>
  <div class="flex w-full flex-col items-center justify-center">
    <span
      class="is-heading break-long-words is-lg group flex items-end self-center p-6 text-center font-heading text-xl font-medium xs:text-xl sm:text-2xl lg:text-3xl">
      {{ headerName | translate }}
    </span>
    <div class="flex w-screen max-w-[500px] flex-col p-6">
      <router-outlet />
    </div>
  </div>
</div>
